import type { ProtocolMetadata } from "@/types";
import type { Strategies } from "@/../config/swr.config";
import useApi from "@/hooks/api/useApi";

/**
 * @package api:go
 * @link https://superform-xyz.postman.co/workspace/Superform~fe57d318-f198-4f97-9c50-0b2a5a78dbac/request/3472327-ab6aff5c-aa91-469d-a9f5-fd1a8a3e3557?ctx=documentation
 * @param {boolean} strategy
 */
export default function useProtocols(strategy: Strategies = "default") {
  const { data, isLoading, isError, mutate } = useApi<ProtocolMetadata[], ProtocolMetadata[]>(
    {
      path: "/protocols/",
      api: "v2",
    },
    {
      strategy: strategy,
    }
  );

  return {
    data,
    isLoading,
    isError,
    mutate,
  };
}
